import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=bad8e1e2&lang=pug"
import script from "./ContactBox.vue?vue&type=script&lang=ts"
export * from "./ContactBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports